import { emailApiClient } from './emailApiClient';

export interface ThreadContact {
  contactId: string;
  previousContactId: string | null;
  initiationMethod: string;
  initiationTimestamp: string;
  disconnectTimestamp: string | null;
}

export const fetchEmailThread = async (contactId: string): Promise<ThreadContact[]> => {
  const params = new URLSearchParams({ contactId });

  const response = await emailApiClient(`/thread?${params.toString()}`, {
    method: 'GET'
  });

  if (!response.ok) throw new Error(`API responded with status ${response.status}`);

  const json = (await response.json()) as { meta: { version: string }; data: ThreadContact[] };
  return json.data ?? [];
};
